export var GLOBALFONTFAMILY = [
    {
        countries: ['CES', 'HRV', 'HUN', 'POL', 'RON', 'SLK', 'SLV', 'SRP', 'ROU'],
        fontFamily: 'Castrol Sans Central European,Arial,Helvetica,sans-serif',
    },
    {
        countries: ['BUL', 'KAZ', 'RUS', 'UKR'],
        fontFamily: 'Castrol Sans Cyrillic,Arial,Helvetica,sans-serif',
    },
    {
        countries: ["AZE"],
        fontFamily: "HelveticaNeue-Bold",
    },
    {
        countries: ['VIE'],
        fontFamily: 'Castrol Sans VI Regular',
    },
    {
        countries: [
            'DAN',
            'DEU',
            'ENG',
            'SPA',
            'FIN',
            'FRA',
            'ITA',
            'NLD',
            'NOR',
            'POR',
            'SWE',
        ],
        fontFamily: 'Castrol Sans Western European,Arial,Helvetica,sans-serif',
    },
    {
        countries: ['JPN'],
        fontFamily: 'Meiryo,MS PGothic,Arial,Helvetica,sans-serif',
    },
];
export var ENABLEDWORKSHOPSOWNER = [
    'NLD',
    'DEU',
    'FRA',
    'RUS',
    'AUT',
    'FIN',
    'DAN',
    'SWE',
    'NOR',
    'CHE',
    'ITA',
    'GBR',
    'POL',
    'HUN',
    'CHE',
    'AUS',
    'NZL'
];
export var QUICKSEARCH_DISABLE_COUNTRIES = [
    'POL',
    'CZE',
    'HUN',
    'SVK'
];
export var ENABLED_LICENSE_PLATE_COUNTRIES = ['USA', 'AUS', 'GBR'];
